import React, { useCallback, useEffect, useMemo } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import NotFoundScreen from './aena/notfound'
import ServicePetitionAena from './aena/service-petition'
// import CommonGroup from './modules/Common/navigations/CommonGroup'
import { AppNavigationState, useAppSelector } from '@front/store'
import { Loading } from './components/apploader'
import AenaGroup from './aena/rutas'
import { addXHeaders } from '@front/apis'

interface RootStackScreenProps {
  isLoggedIn: AppNavigationState
}

const RootStackScreen: React.FC<RootStackScreenProps> = ({ isLoggedIn = 'NOT_LOGGED_IN' }) => {
  const screenForAppState = useCallback(
    (isLoggedIn: AppNavigationState) => [
      isLoggedIn === 'NOT_LOGGED_IN' ? [<Route path="/auth/*" element={<NotFoundScreen />} key="auth" />] // Not logged in
        : isLoggedIn === 'LOGGED_IN' ? [<Route path="/browse/*" element={<NotFoundScreen />} key="browse" />] // Logged in
          : [<Route path="/aena/*" element={<AenaGroup />} key="aena" />], // Logged in services only
    ],
    [isLoggedIn],
  )

  const initialRoute = useMemo(() => {
    if (isLoggedIn === 'LOGGED_IN_SERVICES') {
      return <Route path="/" element={<Navigate to="/services/" />} />
    } else {
      return <Route path="/" element={<Navigate to="/not-found" />} />
    }
  }, [isLoggedIn])

  const unkownRoute = useMemo(() => {
    if (isLoggedIn === 'LOGGED_IN') {
      return <Route path="*" element={<Navigate to="/not-found" />} />
    } else if (isLoggedIn === 'LOGGED_IN_SERVICES') {
      return <Route path="*" element={<Navigate to="/not-found" />} />
    } else {
      return <Route path="*" element={<Navigate to="/not-found" />} />
    }
  }, [isLoggedIn])

  return (
    <Routes>
      {initialRoute}
      {screenForAppState(isLoggedIn)}
      <Route path='aena/service-petition' element={<ServicePetitionAena/>} />
      <Route path="not-found" element={<NotFoundScreen />} />
      {/* deshabilitamos el unkownRoute para que no se redirija a la pagina de not found en dev */}
      {/* {unkownRoute} */}
    </Routes>
  )
}

const RootStackScreenMemo = React.memo(RootStackScreen, (prevProps, nextProps) => {
  return prevProps.isLoggedIn === nextProps.isLoggedIn
})

const AppNavigator: React.FC = () => {
  const appState = useAppSelector((state) => state.appState.appNavigationState)
  const isLoading = useAppSelector((state) => state.loading.isLoading)
  const token = useAppSelector((state) => state.user.token)
  const appGUID = useAppSelector((state) => state.user.e360AppGUID)
  const appUserGUID = useAppSelector((state) => state.user.e360AppUserGUID)

  if ((appState === 'LOGGED_IN_SERVICES' || appState === 'LOGGED_IN') && token && appGUID && appUserGUID) {
    // console.log("navigatinggg:",appState, token, appGUID, appUserGUID)
    addXHeaders({
      token,
      e360AppGUID: appGUID,
      e360AppUserGUID: appUserGUID,
    }).then(() => {
      return (
        <Loading loading={isLoading} lottieSource={require('./assets/lottie/loading.json')}>
          <RootStackScreenMemo isLoggedIn={appState} />
        </Loading>
      )
    })
  }

  return (
    <Loading loading={isLoading} lottieSource={require('./assets/lottie/loading.json')}>
      <RootStackScreenMemo isLoggedIn={appState} />
    </Loading>
  )
}

export default AppNavigator
